import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setEmployeeData } from "../../actions/employeeSlice";

function validEmail(email) {
  const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
    email || "",
  );
  return isValidEmail;
}
function validPhone(x) {
  const out = /^[0-9]+$/.test(x || "");
  return out;
}

const usePersonalInformation = () => {
  const dispatch = useDispatch();

  const { activeIndex, personalInformation } = useSelector(
    (state) => state.employeeregister,
  );

  useEffect(() => {
    dispatch(
      setEmployeeData({
        key: "isEdit",
        value: true,
      }),
    );
    dispatch(
      setEmployeeData({
        key: "personalInformation",
        value: {
          given_name: "",
          other_name: "",
          last_name: "",
          preferred_name: "",
          tax_identification_no: "",
          national_id: "",
          social_security_number: "",
          personal_email: "",
          work_email: "",
          phone_code: "",
          phone: "",
        },
      }),
    );
  }, []);

  useEffect(() => {
    handleEnableNext();
  }, [activeIndex, personalInformation]);

  useEffect(() => {
    if (
      personalInformation?.given_name ||
      personalInformation?.other_name ||
      personalInformation?.last_name ||
      personalInformation?.preferred_name ||
      personalInformation?.tax_identification_no ||
      personalInformation?.national_id ||
      personalInformation?.social_security_number ||
      personalInformation?.personal_email ||
      personalInformation?.work_email ||
      personalInformation?.phone_code ||
      personalInformation?.phone
    ) {
      dispatch(
        setEmployeeData({
          key: "isLeaveModal",
          value: true,
        }),
      );
    }
  }, [personalInformation]);

  const handleEnableNext = () => {
    if (activeIndex === 0) {
      if (
        personalInformation?.given_name &&
        personalInformation?.last_name &&
        personalInformation?.personal_email &&
        validEmail(personalInformation?.personal_email) &&
        personalInformation?.phone &&
        validPhone(personalInformation?.phone) &&
        personalInformation?.phone_code &&
        validPhone(personalInformation?.phone_code) &&
        personalInformation?.work_email &&
        validEmail(personalInformation?.work_email)
      ) {
        dispatch(
          setEmployeeData({
            key: "nextBtnEnable",
            value: true,
          }),
        );
      } else {
        dispatch(
          setEmployeeData({
            key: "nextBtnEnable",
            value: false,
          }),
        );
      }
    }
  };
  const onChangePersonalInfo = (name, value) => {
    dispatch(
      setEmployeeData({
        key: "personalInformation",
        value: { ...personalInformation, [name]: value },
      }),
    );
  };

  return {
    onChangePersonalInfo,
    personalInformation,
  };
};

export default usePersonalInformation;
